import type { TableData, TableRow } from './types'

const HEADER_ROW_KEY = '__header__'

export const createDefaultPlanTableData = (): TableData => ({
  columns: [{ key: 'col-1' }, { key: 'col-2' }],
  rows: [
    {
      key: 'row-1',
      cells: [
        { columnKey: 'col-1', value: [''] },
        { columnKey: 'col-2', value: [''] },
      ],
    },
  ],
  headerRow: {
    key: HEADER_ROW_KEY,
    cells: [
      { columnKey: 'col-1', value: ['Spalte 1'] },
      { columnKey: 'col-2', value: ['Spalte 2'] },
    ],
  },
  settings: {
    borderColorHex: '000000',
    borderWidth: 0.5,
    cellTextMargin: 1.5,
  },
})

export const createDefaultHeaderRow = (columnKeys: string[]): TableRow => ({
  key: HEADER_ROW_KEY,
  cells: columnKeys.map((columnKey, index) => ({
    columnKey,
    value: [`Spalte ${index + 1}`],
  })),
})

export const createEmptyDataRow = (columnKeys: string[], rowIndex: number): TableRow => ({
  key: `row-${rowIndex}`,
  cells: columnKeys.map(columnKey => ({
    columnKey,
    value: [''],
  })),
})

const createNextColumnKey = (existingColumns: { key: string }[]): string => {
  const existingKeys = new Set(existingColumns.map(column => column.key))
  let index = existingColumns.length + 1
  let key = `col-${index}`
  while (existingKeys.has(key)) {
    index += 1
    key = `col-${index}`
  }
  return key
}

export const addColumnToTable = (table: TableData): TableData => {
  const columnKey = createNextColumnKey(table.columns)
  const columnIndex = table.columns.length + 1
  const headerRow =
    table.headerRow ?? createDefaultHeaderRow(table.columns.map(column => column.key))

  return {
    ...table,
    columns: [...table.columns, { key: columnKey }],
    headerRow: {
      ...headerRow,
      cells: [...headerRow.cells, { columnKey, value: [`Spalte ${columnIndex}`] }],
    },
    rows: table.rows.map(row => ({
      ...row,
      cells: [...row.cells, { columnKey, value: [''] }],
    })),
  }
}
